import { render, staticRenderFns } from "./SidebarGroup.vue?vue&type=template&id=2f8de9c8&scoped=true&"
import script from "./SidebarGroup.vue?vue&type=script&lang=js&"
export * from "./SidebarGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8de9c8",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListGroup } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VListGroup,VListItem,VListItemAction,VListItemTitle})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f8de9c8')) {
      api.createRecord('2f8de9c8', component.options)
    } else {
      api.reload('2f8de9c8', component.options)
    }
    module.hot.accept("./SidebarGroup.vue?vue&type=template&id=2f8de9c8&scoped=true&", function () {
      api.rerender('2f8de9c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lib/src/components/navigation/components/SidebarGroup.vue"
export default component.exports